import React, { useContext } from "react";
import { EditReservationContext } from "./EditReservationContext";


export default function ReservationHistoryTab() {
  const c = useContext(EditReservationContext);
  if (!c) return null;
  return (
    <div className="editReservationPopup__history">
       <div className="editReservationPopup__history-header">
          <button
             className="editReservationPopup__btn editReservationPopup__btn--normal"
             onClick={() => c.setView("form")}
          >
             Înapoi
          </button>
          <button
             className="editReservationPopup__btn editReservationPopup__btn--normal"
             onClick={c.loadHistory}
             disabled={c.historyLoading}
             title="Reîncarcă istoricul"
          >
             {c.historyLoading ? "Se încarcă…" : "Reîncarcă"}
          </button>
       </div>

       <div className="editReservationPopup__history-grid-wrapper">
          <div className="editReservationPopup__history-grid">
             {c.historyError ? (
                <div className="editReservationPopup__history-placeholder">
                   {c.historyError}
                </div>
             ) : c.historyLoading ? (
                <div className="editReservationPopup__history-placeholder">
                   Se încarcă istoricul…
                </div>
             ) : (c.formattedHistory || []).length === 0 ? (
                <div className="editReservationPopup__history-placeholder">
                   Nu există modificări pentru această rezervare.
                </div>
             ) : (
                c.formattedHistory.map((entry, index) => {
                   return (
                      <div
                         key={entry.id + "-" + index}
                         className="editReservationPopup__history-item"
                      >
                         <div className="editReservationPopup__history-meta">
                            <span className="editReservationPopup__history-meta-label">
                               Data / ora
                            </span>
                            <span
                               className={[
                                  "editReservationPopup__history-meta-value",
                                  entry.card?.changed?.startTime
                                     ? "is-changed"
                                     : "",
                               ]
                                  .filter(Boolean)
                                  .join(" ")}
                            >
                               {entry.time || "-"}
                            </span>

                            <span className="editReservationPopup__history-meta-label">
                               Modificat de
                            </span>
                            <span className="editReservationPopup__history-meta-value">
                               {entry.by || "-"}
                            </span>
                         </div>

                         <article
                            className={[
                               "studentsProfileUI__reservationCard",
                               "editReservationPopup__history-reservation-card",
                               entry.card?.changed?.color ? "is-changed" : "",
                            ]
                               .filter(Boolean)
                               .join(" ")}
                            style={{
                               background:
                                  entry.card?.colorCss || "var(--event-default)",
                            }}
                         >
                            {entry.card?.isCancelled ? (
                               <span className="studentsProfileUI__reservationDot" />
                            ) : null}

                            <p
                               className={[
                                  "studentsProfileUI__reservationDate",
                                  "editReservationPopup__history-res-line",
                                  entry.card?.changed?.startTime
                                     ? "is-changed"
                                     : "",
                               ]
                                  .filter(Boolean)
                                  .join(" ")}
                            >
                               {entry.card?.date || "—"}
                               {entry.card?.time ? ", " : ""}
                               {entry.card?.time ? (
                                  <span className="studentsProfileUI__reservationTime">
                                     {entry.card.time}
                                  </span>
                               ) : null}
                            </p>

                            <p
                               className={[
                                  "studentsProfileUI__reservationMeta",
                                  "studentsProfileUI__reservationMeta--sub",
                                  "editReservationPopup__history-res-line",
                                  entry.card?.changed?.userId ||
                                  entry.card?.changed?.instructorId
                                     ? "is-changed"
                                     : "",
                               ]
                                  .filter(Boolean)
                                  .join(" ")}
                            >
                               Cu{" "}
                               {entry.card?.student ||
                                  entry.card?.instructor ||
                                  "-"}
                            </p>

                            <p
                               className={[
                                  "studentsProfileUI__reservationMeta",
                                  "editReservationPopup__history-res-line",
                                  entry.card?.changed?.meta ? "is-changed" : "",
                               ]
                                  .filter(Boolean)
                                  .join(" ")}
                            >
                               {entry.card?.sector || "—"} ·{" "}
                               {entry.card?.gearbox || "—"}
                               {entry.card?.isFavorite ? (
                                  <span className="studentsProfileUI__reservationFlag">
                                     {" "}
                                     ⁂
                                  </span>
                               ) : null}
                               {entry.card?.isImportant ? (
                                  <span className="studentsProfileUI__reservationFlag">
                                     {" "}
                                     ‼
                                  </span>
                               ) : null}
                            </p>

                            {entry.card?.note ? (
                               <p
                                  className={[
                                     "studentsProfileUI__reservationMeta",
                                     "editReservationPopup__history-res-line",
                                     entry.card?.changed?.privateMessage
                                        ? "is-changed"
                                        : "",
                                  ]
                                     .filter(Boolean)
                                     .join(" ")}
                               >
                                  {entry.card.note}
                               </p>
                            ) : null}
                         </article>
                      </div>
                   );
                })
             )}
          </div>
       </div>
    </div>
  );
}
